import { ClientIntakeStatus, CoachClientSlot, CoachClientStatus, CoachIntakeMode, isSlotSleeping } from '@cf-shared/data-model/coach';

/**
 * Whether this client has a program the coach can work on inside their account: the client has
 * claimed the invite, and the intake is done. A coach-filled intake is done before the invite goes
 * out; a client-filled one only once the coach has finalized it (#3389). Until then the detail
 * page offers Review Intake or Fill Intake Myself instead of Manage Client.
 */
export function isClientProgramReady(slot: CoachClientSlot | undefined): boolean {
  if (slot?.status !== CoachClientStatus.Claimed) return false;
  if (slot.intakeMode !== CoachIntakeMode.ClientFills) return true;
  return slot.clientIntakeStatus === ClientIntakeStatus.Finalized;
}

/**
 * Whether a client card on the Coaching list shows the Training Overview button (#6795).
 *
 * Shown only when the tap can work: the Training Overview is behind the coaching dashboard switch
 * (the coach's own value decides, `coaching-dashboard-flag.ts`), the client has a program
 * (`isClientProgramReady`), the client is not asleep (entering their account is refused, #4530),
 * and the client is not a demo client (there is no real account behind it).
 */
export function isTrainingOverviewEntryShown(
  slot: CoachClientSlot,
  context: { coachingDashboardOn: boolean, isDemoClient: boolean },
): boolean {
  return context.coachingDashboardOn
    && !context.isDemoClient
    && !!slot.clientUid
    && isClientProgramReady(slot)
    && !isSlotSleeping(slot);
}
